import noticeDetail from './notice-detail.vue'

export default noticeDetail
